<template>
  <NavBar v-if="!isMobile()" ></NavBar>
  <NavBarmob v-if="isMobile()"></NavBarmob>
  <ContactUsBanner> </ContactUsBanner>
  <main>

    <GetInTouch></GetInTouch>
    <ContactForm></ContactForm>
    <SiteFooter v-if="!isMobile()"></SiteFooter>
    <Footermob v-if="isMobile()"></Footermob>
  </main>
</template>

<script>
import SiteFooter from "../UI/SiteFooter.vue";
import NavBar from "../UI/NavBar.vue";
import ContactForm from "./ContactForm.vue";
import ContactUsBanner from "./ContactUsBanner.vue";
import GetInTouch from "./GetInTouch.vue";
import NavBarmob from "../UI/NavBarmob.vue";
import Footermob from "../Indexmobile/IndexFooter.vue";

export default {
  components: {
    SiteFooter,
    ContactForm,
    GetInTouch,
    NavBar,
    NavBarmob,
    Footermob,
    ContactUsBanner,
  },
  mounted:async function(){
    var mastHeight=document.querySelector('.page-header, .slider').clientHeight;
    document.querySelector('main').style.marginTop=mastHeight+"px";
  },
  methods:{
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
  }
};
</script>
